import { Paper, Box, Typography, Avatar, InputLabel, IconButton } from '@mui/material'
import React, { useState, useEffect, useRef } from 'react';
import dayjs from 'dayjs';
import axios from 'axios';
import { useMycontext } from '../components/global/MyContext';
import { Link, useNavigate } from 'react-router-dom';
import video from '../assets/video/intro.mp4'
import topad from '../assets/images/topad.jpeg'
import growth from '../assets/icons/growth.png'
import CountUp from 'react-countup';
import CircleLoading from '../components/global/circleloading';
import { Facebook, Share, Twitter, WhatsApp } from '@mui/icons-material';
import { FacebookShareButton, TwitterShareButton, WhatsappShareButton } from 'react-share';
import { Helmet } from 'react-helmet';


const Home = (props) => {

    const { apiUrl } = useMycontext();
    const [page, setPage] = useState(0);
    const getRecent = () => {
        axios.get(apiUrl + 'post/getall?offset=' + page)
            .then(function (response) {
                if (response.data.status) {
                    if (props.post[0]?.id !== response.data.data[0].id) {
                        props.setPost((prev) => [...prev, ...response.data.data]);
                    }
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const handelInfiniteScroll = async () => {
        try {
            if (
                window.innerHeight + document.documentElement.scrollTop + 50 >= document.documentElement.scrollHeight) {
                setPage((prev) => prev + 1);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handelInfiniteScroll);
        return () => window.removeEventListener("scroll", handelInfiniteScroll);
    }, []);

    useEffect(() => {
        getRecent();
    }, [page]);

    return (
        <>
            <Helmet>
                <title>Dainik Shabd Shodh</title>
            </Helmet>
            {props.post.length === 0 && <CircleLoading />}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
                <Paper sx={{ borderRadius: "15px", display: { xs: "none", md: "block" } }}>
                    <video width="100%" height="auto" controls style={{ borderRadius: "15px" }}>
                        <source src={video} type="video/mp4" />
                    </video>
                </Paper>
                <Box sx={{ display: { xs: "block", md: "none" }, textAlign: "center", maxHeight: "200px" }}>
                    <img src={topad} width="100%" style={{ borderRadius: "10px" }} />
                </Box>
                {props.post.map((item, index) => {
                    const url = `https://shabdshodh.in/share/post?url=${item.eng_sub_category}&id=${item.id}`;
                    return (
                        <Paper key={index} sx={{ borderRadius: "15px", padding: "10px 10px 0px 10px", position: "relative" }}>
                            <Link to={'/' + item.eng_sub_category + '/' + item.id} style={{ color: "#000" }}>
                                <Box sx={{ display: "flex", gap: "8px" }}>
                                    <Box sx={{ flex: { xs: 1.6, sm: 2.5, md: 2.8 } }}>
                                        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                            <Typography variant="h6" sx={{ backgroundColor: item.color !== null ? item.color : "#ff6600", color: "#ffffff", padding: "0px 4px", borderRadius: "4px", textTransform: "capitalize" }}>{item.eng_category}</Typography>
                                            <InputLabel>
                                                {dayjs().diff(item.created_at, 'minutes') < 60
                                                    ? dayjs().diff(item.created_at, 'minutes') + " मिनट पहले"
                                                    : dayjs().diff(item.created_at, 'hour') < 24
                                                        ? dayjs().diff(item.created_at, 'hour') + " घंटे पहले"
                                                        : dayjs().diff(item.created_at, 'day') < 6
                                                            ? dayjs().diff(item.created_at, 'day') + " दिन पहले"
                                                            : dayjs(item.created_at).format('DD-MMM-YYYY')}
                                            </InputLabel>
                                        </Box>
                                        <Box sx={{ marginTop: "10px" }}>
                                            <Typography component='p' variant='p' sx={{ fontSize: { xs: "18px", md: "22px" }, fontWeight: "600", textAlign: "justify", textJustify: "inter-word" }}><span style={{ color: item.color }}>{item.color_title !== null ? item.color_title + " : " : ""}</span>{item.title}</Typography>
                                        </Box>
                                    </Box>
                                    <Box sx={{ flex: 1, minHeight: "120px", maxHeight: "200px" }}>
                                        <Avatar src={apiUrl + "assets/post-img/" + item.id + ".png"} sx={{ borderRadius: "10px", width: "100%", height: "100%" }} />
                                    </Box>
                                </Box>
                            </Link>
                            <Box sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", gap: "5px", paddingTop: "3px" }}>
                                <Box sx={{ flex: { xs: 1.6, sm: 2.5, md: 2.8 }, display: 'flex', alignItems: "center", gap: "5px" }}>
                                    <Avatar sx={{ height: "20px", maxWidth: "20px" }}></Avatar>
                                    <Typography color='secondary' variant='h6' sx={{ marginTop: "2px" }}> {item.posted_by}</Typography>
                                </Box>
                                <Box sx={{ flex: 1, display: "flex", gap: "5%", justifyContent: "center", alignItems: "center" }}>
                                    <IconButton sx={{ padding: "5px" }}><FacebookShareButton url={url}><Facebook /></FacebookShareButton></IconButton>
                                    <IconButton sx={{ padding: "5px" }}><TwitterShareButton url={url}><Twitter /></TwitterShareButton></IconButton>
                                    <IconButton sx={{ padding: "5px" }}><WhatsappShareButton url={url} separator=" :: "><WhatsApp /></WhatsappShareButton></IconButton>
                                    <IconButton sx={{ padding: "5px", display: { xs: "none", sm: "block" } }} color='primary'
                                        onClick={() => {
                                            navigator.clipboard.writeText(url)
                                                .then(() => alert("Link Copied"))
                                        }}><Share />
                                    </IconButton>
                                </Box>
                            </Box>
                        </Paper>
                    )
                })}
            </Box>
        </>
    )
}

export default Home